import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const PartiallyCheckedIcon = _ref => {
  let {
    width = 20,
    height = 20
  } = _ref;
  return /*#__PURE__*/_jsxs("svg", {
    width: "".concat(width),
    height: "".concat(height),
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("rect", {
      x: "0.5",
      y: "0.5",
      width: "21",
      height: "21",
      rx: "4.5"
    }), /*#__PURE__*/_jsx("path", {
      d: "M6 11C6 10.4477 6.44772 10 7 10H15C15.5523 10 16 10.4477 16 11C16 11.5523 15.5523 12 15 12H7C6.44772 12 6 11.5523 6 11Z",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("rect", {
      x: "0.5",
      y: "0.5",
      width: "21",
      height: "21",
      rx: "4.5"
    })]
  });
};